import { Stack } from '@mui/material';
import styled from 'styled-components';

import { TInnerDataTableHeaderContainer } from '@/shared/components/ui/data-table/variant/inner-data-table/components/inner-data-table-header/inner-data-table-header.types';

export const InnerPageDataTableHeaderContainer = styled(
  Stack,
)<TInnerDataTableHeaderContainer>`
  && {
    flex-direction: row;
    background-color: ${({ theme }) => theme.palette.background.paper};
    border-radius: ${({ theme }) =>
      `${theme.shape.containerRadius} ${theme.shape.containerRadius} 0 0`};

    height: 4rem;
    min-height: 4rem;
    padding: 0 1.25rem;
    gap: 1.25rem;
    align-items: center;
    justify-content: ${({ $isLoading }) =>
      $isLoading ? 'flex-end' : 'space-between'};
    width: 100%;

    box-shadow: ${({ theme }) =>
      `inset 0 -1px 0 0 ${theme.palette.stroke.secondaryLight}`};
  }
`;
